import { useSelectedDealer, useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { useTypedQuery } from "hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { LOCATION_LICENSES_STORAGE_KEYS } from "modules/LocationLicenseOverview/storageKeys";
import { getPreference } from "utils/common";

const useDefaultLocationLicensesDashboardFilters = () => {
  const { selectedDealer } = useSelectedDealer();
  const { selectedLocation } = useSelectedLocation();

  return {
    dealer: getPreference(LOCATION_LICENSES_STORAGE_KEYS.DealerPreference, selectedDealer || null),
    location: getPreference(LOCATION_LICENSES_STORAGE_KEYS.LocationPreference, selectedLocation || null)
  };
};

export const useLocationLicensesDashboardFilters = () =>
  useTypedQuery({ queryKey: LocationLicenseOverviewKeys.filters, initialData: useDefaultLocationLicensesDashboardFilters() }).data;
